import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { MyRouterContext } from '@/App';
import { BeforeLoadContext, LoaderFnContext } from '@tanstack/react-router/dist/esm/route';
import { suppress404 } from '@/lib/zodius';

export const Route = createFileRoute('/_main/_project/project')({
  beforeLoad,
  loader,
  component: () => <Outlet />,
});

async function loader({
  context: { adminClient, projectId, userInfo },
}: LoaderFnContext<{ projectId: string }, { project: string | undefined }, MyRouterContext>) {
  let project = null;
  if (projectId) {
    project = await suppress404(
      adminClient.settings_v1_get_project({
        params: { project_id: projectId },
      })
    );
  }
  const tenant = await adminClient.settings_v1_get_tenant();
  return {
    tenant,
    project,
    projectId,
    adminClient,
    userInfo,
  };
}

async function beforeLoad({
  search,
  context,
}: BeforeLoadContext<{ project?: string }, Record<never, string>, MyRouterContext>) {
  // Redirect if the projectId is resolved from context but not in search query
  if (!search.project && context.projectId) {
    throw redirect({ to: '.', search: { project: context.projectId } });
  }
  return context;
}
